import { useContext, useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { MODAL_RESPONSE_TYPE } from '../../constants/modal.constants';
import { ModalContext } from '../../context/Modal.context';

const RouteLeavingGuard = ({ when }) => {
  const { t: common } = useTranslation('common');
  const { openConfirmModal } = useContext(ModalContext);

  const blocker = useBlocker(when);

  useEffect(() => {
    if (blocker.state !== 'blocked') return;

    openConfirmModal(common('warningToastHeading'), common('changesNotSaved')).then((response) => {
      if (response === MODAL_RESPONSE_TYPE.ACCEPT) {
        blocker.proceed();
      } else {
        blocker.reset();
      }
    });
  }, [blocker, openConfirmModal, common]);

  return null;
};

export default RouteLeavingGuard;
